import menuRoute from "./modules/menuRoute";

const getters = {
  token: state => state.user.token,
  userSession: state => state.user.userSession,

  avatar: state => state.user.userSession.avatar,
  username: state => state.user.userSession.username,
  nickName: state => state.user.userSession.nickName,
  roles: state => state.user.userSession.roles,

  sidebar: state => state.app.sidebar,
  showBreadcrumb: state => state.app.showBreadcrumb,
  device: state => state.app.device,
  theme: state => state.app.theme,
  skin: state => state.app.skin,
  topNav: state => state.app.topNav,

  showSideBar: state => state.datavisual.showSideBar,
  showPropsBar: state => state.datavisual.showPropsBar,

  // dictType: state => state.dict.type,
  // dictLabel: state => state.dict.label,

  dictType: state => state.dict.valueDataList,
  dictTypeMap: state => state.dict.valueDataMap,
  dictLabel: state => state.dict.labelDataMap,

  visitedViews: state => state.tabsView.visitedViews,
  cachedViews: state => state.tabsView.cachedViews,
  routes: state => state.menuRoute.routes,
  menuRoutes: state => state.menuRoute.menuRoutes,
  sidebarMenuRoutes: state => state.menuRoute.sidebarMenuRoutes,
  menuCopyRoutes: state => state.menuRoute.menuCopyRoutes,
  lastActiveMenuPath: state => state.menuRoute.lastActiveMenuPath,
  permissions: state => state.menuRoute.permissions,

}
export default getters
